import { getJSON } from "./";

export default function dashboard(query) {
  return getJSON("Cases/Stats", {
    types: ["Service Request", "Incident"],
    ...query,
  });
}
